import { currency } from '@filters/shared-filters';
import { SolicitorNoticeDetails } from 'types/marketing-site';

export const defaultSolicitorNotice: SolicitorNoticeDetails = {
	name: 'the partner',
	payment: currency(1000, 0),
	monthlyPayment: '',
	isCpaPartner: false,
	isInvestor: false,
	customCondition: ''
};

export const regAFundListing = {
	content: [
		'Below are the individual websites of each Regulation A Fund:',
		'<ul class="ul"><li><a href="http://fundrise.com/eastcoast">Fundrise East Coast Opportunistic REIT</a></li>' +
			'<li><a href="http://fundrise.com/heartland">Fundrise Midland Opportunistic REIT</a></li>' +
			'<li><a href="http://fundrise.com/westcoast">Fundrise West Coast Opportunistic REIT</a></li>' +
			'<li><a href="http://fundrise.com/growth1">Fundrise Equity REIT</a></li>' +
			'<li><a href="http://fundrise.com/efund">Fundrise eFund</a></li>' +
			'<li><a href="http://fundrise.com/growth2">Fundrise Growth eREIT II</a></li>' +
			'<li><a href="http://fundrise.com/growth3">Fundrise Growth eREIT III</a></li>' +
			'<li><a href="http://fundrise.com/devreit">Fundrise Development eREIT</a></li>' +
			'<li><a href="http://fundrise.com/growth7">Fundrise Growth eREIT VII</a></li>' +
			'<li><a href="http://fundrise.com/balanced2">Fundrise Balanced eREIT II</a></li></ul>'
	],
	centeredContent: false
};
